import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoleFormComponent } from './role-form.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { FuseSharedModule } from '@fuse/shared.module';
import { RoleService } from './role.service';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { AngularDualListBoxModule } from 'app/components/dual-list/angular-dual-listbox.module';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatChipsModule} from '@angular/material/chips';



@NgModule({
    declarations: [
        RoleFormComponent
    ],
    imports: [
        CommonModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatTableModule,
        FuseSharedModule,
        AngularDualListBoxModule,
        MatAutocompleteModule,
        MatChipsModule

    ],
    exports: [
        RoleFormComponent
    ],
    providers : [ 
        RoleService
    ]
})
export class RoleFormModule { }
